import {
  useTransportMutation,
  useTransportQuery,
  useTransportQueryUtils,
} from "@/transport"

export function useUploadedAudioSettingsTransport() {
  const query = useTransportQuery({ operation: "getOrganizationSettings" })
  const mutation = useTransportMutation("updateOrganizationSettings")
  const queryUtils = useTransportQueryUtils()
  return {
    query,
    mutation,
    invalidate: () => queryUtils.invalidateOperation("getOrganizationSettings"),
  }
}
